export const THIS_BASE_HOST =
  typeof window !== 'undefined' ? window.location.origin : ''

type QueryParams = Record<string, string | number | boolean | undefined>

/**
 * Properly joins a base URL with a path, preserving the base URL's path segments
 * even when the path starts with a slash.
 */
function joinUrl(baseUrl: string, path: string): string {
  // Remove trailing slash from baseUrl if present
  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
  // Remove leading slash from path if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path

  return `${base}/${cleanPath}`
}

export function makeUrl(
  base: string,
  path: string,
  params?: QueryParams
): string {
  // Properly join the base and path to ensure no path segments are lost
  const urlString = joinUrl(base, path)
  const url = new URL(urlString)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        url.searchParams.append(key, String(value))
      }
    })
  }

  return url.toString()
}
